import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import { hmLightTheme } from "../../../themes/hmTheme";
import formatCurrency from "../../../unit/formatCurrency";
import formatInt from "../../../unit/formatInt";
import HeaderLabelGridField from "../../../unit/HeaderLabelGridField";
import HeaderLabelTitle from "../../../unit/HeaderLabelTitle";
import HeaderLabelValue from "../../../unit/HeaderLabelValue";
import VerticalSpacer from "../../../unit/VerticalSpacer";

const CreditSumaryTableTitle = () => {
  return (
    <Grid container>
      <Grid item xs={2}></Grid>
      <Grid item xs={1}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: "bold" }}
        >
          Total
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: "bold" }}
        >
          Open
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: "bold" }}
        >
          Current Balance
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: "bold" }}
        >
          High Balance
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: "bold" }}
        >
          Monthly Payment
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: "bold" }}
        >
          Past Due
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: "bold" }}
        >
          %Available
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: "bold" }}
        >
          Avg Payment History
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: "bold" }}
        >
          Avg Ontime Payment
        </Typography>
      </Grid>
    </Grid>
  );
};
function arrAverageNum(arr: any) {
  var sum = 0;
  for (var i = 0; i < arr.length; i++) {
    sum += parseInt(arr[i]);
  }
  var rs = ((sum / arr.length) * 100) / 100;
  //	return rs?rs.toFixed(2):'';
  return parseInt(rs);
}
function Trim(str) {
  str = str.replace(/(^\s*)|(\s*$)/g, "");
  str = str.replace(/%/, "");
  return str;
}
const paymentAvgHistory = (history: any) => {
  if (history == "" || history == undefined) {
    return "";
  }
  let paymentText = "";
  let paymentTextArr = [];
  let paymentMessage = "";
  let paymentPop = "";
  let startDate = "";
  for (const key in history) {
    if (history[key].paymentPattern) {
      for (const val in history[key].paymentPattern) {
        paymentText += history[key].paymentPattern[val].text;
        startDate = history[key].paymentPattern[val].startDate.content;
      }
      break;
    }
  }
  if (paymentText) {
    return paymentText;
    // return paymentText.length;
    // return paymentText;
    // paymentTextArr = paymentText.split("");
    // let paymentCount = 0;
    // for (const key in paymentTextArr) {
    //   if (paymentTextArr[key] == "1") {
    //     paymentPop += '<span style="color:green;">1</span>';
    //   } else {
    //     paymentPop += '<span style="color:red;">0</span>';
    //   }
    // }
  }
};
const CreditSummaryTable = ({ ...props }) => {
  const { title, data, total } = props;
  let fontFamily =
    props.fontFamily == "numberFontFamily"
      ? hmLightTheme?.palette?.numberFontFamily
      : hmLightTheme?.palette?.textFontFamily;
  let historyData = null;
  if (title == "Installment") {
    historyData = props?.sourcedata?.tradeData?.installment;
  } else if (title == "Revolving") {
    historyData = props?.sourcedata?.tradeData?.revolving;
  } else if (title == "Open") {
    historyData = props?.sourcedata?.tradeData?.open;
  } else if (title == "Mortgage") {
    historyData = props?.sourcedata?.tradeData?.mortgage;
  }
  // console.log("historyData========>>>.", historyData);
  let historyAllData = [];
  let ontimePaymentData = [];

  if (historyData) {
    historyAllData = [];
    for (const key in historyData) {
      if (historyData[key].paymentHistory) {
        const paymentHistory = paymentAvgHistory(
          historyData[key].paymentHistory
        );
        historyAllData.push(paymentHistory?.length || 0);

        //ontime
        // let normal_num = substr_count(paymentHistory, "1");
        //查找里面含有1的个数
        let normal_num = paymentHistory
          ? paymentHistory.split("").filter((item) => item === "1").length
          : 0;
        let normal_num_per = paymentHistory
          ? parseFloat(((normal_num / paymentHistory.length) * 100).toFixed(2))
          : 0;
        ontimePaymentData.push(normal_num_per);
      } else {
        // historyAllData.push(0);
      }
    }
  }

  // console.log("historyAllData========>>>.", title, historyAllData);
  const avg_month = arrAverageNum(historyAllData);
  const avg_ontime = arrAverageNum(ontimePaymentData);

  const creditLimit = data?.creditLimit ? data.creditLimit : 0;
  const currentBalance = data?.currentBalance ? data.currentBalance : 0;

  const m_ava = creditLimit
    ? creditLimit - currentBalance
      ? ((creditLimit - currentBalance) / creditLimit) * 100
      : 100
    : null;
  //-Infinity% 不要显示这个值，如果creditLimit为0，则m_ava为null，显示空字符串
  const m_ava_display =
    m_ava === null || m_ava === -Infinity ? "" : `${m_ava.toFixed(1)}%`;
  const openTotalData = props?.openTotalData;
  let openTotal = props?.openTotal || 0; // 如果父组件传了openTotal就用父组件的，否则统计openTotalData里未关闭的数量
  if (!openTotal) {
    // 统计未关闭的数量（dateClosed 为空或无 content）
    if (Array.isArray(openTotalData)) {
      openTotal = openTotalData.reduce((acc, item) => {
        // installment.tsx 里 dateClosed 的判断方式
        if (!item.dateClosed || !item.dateClosed.content) {
          return acc + 1;
        }
        return acc;
      }, 0);
    }
  }
  return (
    <Grid container rowSpacing={1} columnSpacing={1}>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: "bold", pl: 1 }}
        >
          {title}
        </Typography>
      </Grid>
      <Grid item xs={1}>
        {total ? parseInt(total, 10) : ""}
      </Grid>
      <Grid item xs={1}>
        {openTotal ? openTotal : ""}
      </Grid>
      <Grid item xs={1}>
        <HeaderLabelValue
          value={data ? formatCurrency(data.currentBalance) : ""}
          fontFamily={fontFamily}
        />
      </Grid>
      <Grid item xs={1}>
        <HeaderLabelValue
          value={data ? formatCurrency(data.highCredit) : ""}
          fontFamily={fontFamily}
        />
      </Grid>
      <Grid item xs={1}>
        <HeaderLabelValue
          value={data ? formatCurrency(data.monthlyPayment) : ""}
          fontFamily={fontFamily}
        />
      </Grid>
      <Grid item xs={1}>
        <HeaderLabelValue
          value={data ? formatCurrency(data.pastDue) : ""}
          fontFamily={fontFamily}
        />
      </Grid>
      <Grid item xs={1} sx={{ color: "red" }}>
        {title != "Total" && m_ava_display && <>{m_ava_display}</>}
      </Grid>
      <Grid item xs={1}>
        {/* {historyAllData && historyAllData.length > 0 ? (
          historyAllData.map((item: any, index: any) => (
            <Typography key={index}>{item}</Typography>
          ))
        ) : (
          <Typography></Typography>
        )} */}
        {avg_month != 9999 && !isNaN(avg_month) ? (
          <Typography>{avg_month}</Typography>
        ) : (
          <Typography></Typography>
        )}
      </Grid>
      <Grid item xs={1}>
        {/* <LabelTitle title="Avg Ontime Payment" /> */}
        {avg_ontime != 9999 && !isNaN(avg_ontime) ? (
          <Typography>{avg_ontime}%</Typography>
        ) : (
          <Typography></Typography>
        )}
      </Grid>
    </Grid>
  );
};
const getAllOpenTotal = (sourcedata: any) => {
  let openTotal = 0;
  const tradeData = sourcedata?.tradeData;
  const tradeTypes = ["mortgage", "installment", "revolving", "open"];
  tradeTypes.forEach((type) => {
    const data = tradeData?.[type];
    if (Array.isArray(data)) {
      data.forEach((item: any) => {
        if (!item.dateClosed || !item.dateClosed.content) {
          openTotal += 1;
        }
      });
    }
  });
  return openTotal;
};
const CreditSummary = ({ sourcedata }: any) => {
  const creditSummary = sourcedata.creditSummary;
  // console.log("creditSummary========>>>.", creditSummary);
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <HeaderLabelTitle title="Credit Summary" suffix="" />
      </AccordionSummary>
      <AccordionDetails>
        {creditSummary ? (
          <Grid container rowSpacing={1} columnSpacing={1}>
            <HeaderLabelGridField title="" value="Total" dxs={10} tdxs={2} />
            <HeaderLabelGridField
              title="Public Records"
              value={
                creditSummary.recordCounts &&
                creditSummary.recordCounts.publicRecordCount
                  ? formatInt(creditSummary.recordCounts.publicRecordCount)
                  : ""
              }
              dxs={10}
              tdxs={2}
              fontFamily="numberFontFamily"
            />
            <HeaderLabelGridField
              title="Collection"
              value={
                creditSummary.recordCounts &&
                creditSummary.recordCounts.collectionCount
                  ? formatInt(creditSummary.recordCounts.collectionCount)
                  : ""
              }
              dxs={10}
              tdxs={2}
              fontFamily="numberFontFamily"
            />
            <HeaderLabelGridField
              title="Inquiries"
              value={
                creditSummary.recordCounts &&
                creditSummary.recordCounts.totalInquiryCount
                  ? formatInt(creditSummary.recordCounts.totalInquiryCount)
                  : ""
              }
              dxs={10}
              tdxs={2}
              fontFamily="numberFontFamily"
            />
            <HeaderLabelGridField
              title="Total Trades"
              value={
                creditSummary.recordCounts &&
                creditSummary.recordCounts.totalTradeCount
                  ? formatInt(creditSummary.recordCounts.totalTradeCount)
                  : ""
              }
              dxs={10}
              tdxs={2}
              fontFamily="numberFontFamily"
            />
            <HeaderLabelGridField
              title="Negative Trades"
              value={
                creditSummary.recordCounts &&
                creditSummary.recordCounts.negativeTradeCount
                  ? formatInt(creditSummary.recordCounts.negativeTradeCount)
                  : ""
              }
              dxs={10}
              tdxs={2}
              fontFamily="numberFontFamily"
            />
            <VerticalSpacer />

            <CreditSumaryTableTitle />
            <CreditSummaryTable
              title="Mortgage"
              data={creditSummary.mortgage}
              total={creditSummary?.recordCounts?.mortgageTradeCount}
              openTotalData={sourcedata?.tradeData?.mortgage}
              sourcedata={sourcedata}
              fontFamily="numberFontFamily"
            />
            <CreditSummaryTable
              title="Installment"
              // data={creditSummary.installment}
              data={creditSummary.installmentAmount}
              total={creditSummary?.recordCounts?.installmentTradeCount}
              openTotalData={sourcedata?.tradeData?.installment}
              sourcedata={sourcedata}
              fontFamily="numberFontFamily"
            />
            <CreditSummaryTable
              title="Revolving"
              data={creditSummary.revolvingAmount}
              total={creditSummary?.recordCounts?.revolvingTradeCount}
              openTotalData={sourcedata?.tradeData?.revolving}
              sourcedata={sourcedata}
              fontFamily="numberFontFamily"
            />
            <CreditSummaryTable
              title="Open"
              data={creditSummary.open}
              total={creditSummary?.recordCounts?.openTradeCount}
              openTotalData={sourcedata?.tradeData?.open}
              sourcedata={sourcedata}
              fontFamily="numberFontFamily"
            />
            <CreditSummaryTable
              title="Total"
              data={creditSummary.totalAmount}
              total={creditSummary?.recordCounts?.totalTradeCount}
              openTotal={getAllOpenTotal(sourcedata)}
              sourcedata={sourcedata}
              fontFamily="numberFontFamily"
            />
          </Grid>
        ) : (
          <></>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default CreditSummary;
